import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FadeUp } from "@/components/Motion";

export default function CTASection({
  overline = "Ready when you are",
  title = "Book a no-obligation feasibility assessment.",
  subtitle = "A 30-minute conversation, a satellite review of your roof, and a clear yes/no recommendation. Zero commitment.",
  ctaLabel = "Book Assessment",
  ctaTo = "/contact",
  testId = "cta-section",
}) {
  return (
    <section className="container-seed section-pad" data-testid={testId}>
      <div className="relative overflow-hidden navy-panel grain rounded-2xl border border-white/5">
        <div className="relative z-10 p-10 md:p-16 lg:p-20 flex flex-col lg:flex-row gap-10 lg:gap-16 items-start lg:items-center justify-between">
          <FadeUp className="max-w-2xl">
            <div className="text-overline text-emerald-400">{overline}</div>
            <h2 className="mt-4 font-display font-bold text-white text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05]">
              {title}
            </h2>
            <p className="mt-5 text-slate-300 text-base sm:text-lg leading-relaxed max-w-xl">
              {subtitle}
            </p>
          </FadeUp>
          <FadeUp delay={1}>
            <Link
              to={ctaTo}
              data-testid={`${testId}-cta`}
              className="inline-flex items-center gap-2 bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-semibold py-4 px-7 rounded-lg transition-colors duration-200 group"
            >
              {ctaLabel}
              <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-0.5" strokeWidth={2.5} />
            </Link>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
